<template>
  <company-table :parent-id="companyId" class="mt-3" />
</template>
<script>
import CompanyTable from '../../../../../components/CompanyTable.vue';

export default {
  name: 'company_sub_list',
  components: {
    CompanyTable,
  },
  computed: {
    companyId() {
      return parseInt(this.$route.params.companyId, 10);
    },
  },
  created() {
    this.$store.dispatch('companies/LOAD_DETAIL_DATA');
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/admin/companies/detail/Subsidiaries.vue